var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrippleLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 70,
    viewBox: "0 0 67 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_619_1485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.4593 50.7207C39.8772 50.1842 28.3285 49.1568 16.8103 47.7605C15.9228 47.655 16.2139 48.7589 16.4662 49.1916C16.9182 49.9599 17.7696 50.5341 18.6405 50.6507C30.1587 52.1912 41.749 53.1548 53.3505 53.7024C54.2575 53.7468 53.9941 52.7206 53.7029 52.2297C53.2648 51.5002 52.3385 50.7596 51.4593 50.7207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.72 38.8836C46.1495 36.9306 41.579 34.9776 37.0057 33.0385C36.4676 32.8082 35.5441 32.7027 35.6466 33.5597C35.7491 34.4167 36.6504 35.2101 37.366 35.5263C41.9393 37.5015 46.507 39.4684 51.0886 41.4381C51.6405 41.6711 52.5918 41.7821 52.4865 40.9029C52.3812 40.0237 51.4633 39.2054 50.7256 38.892L50.72 38.8836Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M53.5004 25.3851C45.5467 19.1495 37.604 12.8944 29.6253 6.67539C29.1899 6.32866 28.1028 5.527 27.5702 6.13434C27.0654 6.71118 27.9611 7.78462 28.366 8.10361C36.3003 14.3642 44.2541 20.5999 52.2134 26.8439C52.6626 27.1934 53.7664 28.02 54.3101 27.3932C54.8232 26.8109 53.9109 25.7125 53.4866 25.3824L53.5004 25.3851Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_619_1485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.05,
    height: 44.15,
    fill: "white",
    transform: "translate(29.9766 69.4619) rotate(-123.684)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrippleLines);
export default __webpack_public_path__ + "static/media/TrippleLines.44187ecc696a301b3f94b5f9a40f8a9c.svg";
export { ForwardRef as ReactComponent };